import React from "react";
import Header from "../organisms/Header";
import ContentSkills from "../Templates/ContentSkills";
import Footer from "../organisms/Footer";

const Skills = () => {
    return (
        <div className="Skills">
            <Header />
            <ContentSkills />
            <Footer />
        </div>
    );
}

export default Skills;